import { getFileFromNwCDN } from './nw-cdn'

export const LINKS = {
  TERMS_OF_USE: 'https://www.nerdwallet.com/p/terms-of-use',
  PRIVACY_POLICY: 'https://www.nerdwallet.com/p/privacy-policy',
  NWWP_PRIVACY_POLICY: '/privacy',
  NWWP_SMS_TERMS: '/sms-terms',
  NWWP_GLBA_NOTICE: '/GLBA',
  PRIVACY_PREFERENCES:
    'https://privacyportal.onetrust.com/webform/694a76f6-1f82-455e-b46e-ffeed902c3fa/2e7ca7c2-0dbe-4751-baaf-30bd541f0c50',
  NWWP_CALIFORNIA_PRIVACY: '/california-privacy-policy',
  ADV_2A: 'https://adviserinfo.sec.gov/firm/brochure/337328',
  FORM_CRS: 'https://reports.adviserinfo.sec.gov/crs/crs_337328.pdf',
  GENERAL_DISCLOSURE: getFileFromNwCDN('general_disclosure_20251001.pdf'),
  SCHWAB_CUSTOMER_AGREEMENT: 'https://www.schwab.com/legal/schwab-brokerage-account-agreement',
  EMAIL_UNSUBSCRIBE:
    'https://privacyportal.onetrust.com/webform/694a76f6-1f82-455e-b46e-ffeed902c3fa/821ae4b3-8227-4a6f-b130-56c6c80b9697',
  FUNNEL_CALENDLY_LINK: 'https://calendly.com/d/dz43-q6s-z32/introductory-meeting-with-nerdwallet-wealth-partners/',
  YOUTUBE_DISCLOSURE: getFileFromNwCDN('youtube-disclosure.pdf'),
}
